import { env } from "./env.js";

export const SITE = {
  name: "RDV Systems",
  tagline: "Road Safety Audit 3D and 3D visualization for infrastructure projects",
  url: env("VITE_SITE_URL", "https://www.rdvsystems.com").replace(/\/+$/, ""),
  loginUrl: env("VITE_APP_LOGIN_URL", "https://www.123bimlive.com/login"),
  contactEndpoint: env("VITE_CONTACT_ENDPOINT", ""),
  gaId: env("VITE_GA_ID", ""),
  phone: "+1 (603) 935-8128",
  phoneHref: "tel:+16039358128",
  email: "inquiries@rdvsystems.com",
  foundedYear: 2005,
  offices: [
    { label: "US headquarters", city: "Manchester", region: "New Hampshire", country: "USA" },
    { label: "Israel headquarters", city: "Modi'in", region: "", country: "Israel" },
  ],
  // From the old site's footer, verified 2026-09-16.
  social: [
    { name: "LinkedIn", href: "https://www.linkedin.com/company/rdv-systems/" },
    { name: "YouTube", href: "https://www.youtube.com/@RDVIZ" },
    { name: "Facebook", href: "https://facebook.com/RDVSystems" },
    { name: "Instagram", href: "https://instagram.com/rdvsystems" },
  ],
  videos: {
    rsaSightDistance: "511337314",
    rsaPlanningDesign: "588556437",
    rsaExistingRoads: "454349029",
    rsaFullReport: "380993746",
    rsaAdditionalSafety: "511337194",
  },
  defaultOgImage: "/images/site/og-default.jpg",
};
